
<script>
let authSource = "";
let cropId=''
if (localStorage.getItem("info")) {
  let info = JSON.parse(localStorage.getItem("info"));
  if(info.teacher&&info.teacher.extraInfo){
    cropId=info.teacher.extraInfo.cropid?info.teacher.extraInfo.cropid:''
  }
  authSource = info.authSource;
} else {
  authSource = "";
}
export default {
  authSource,cropId
};
</script>



// WEBPACK FOOTER //
// src/components/authSource.vue